import { useBufferedThrottle } from '@topconagriculture/frontend-utils';
import { path as ramdaPath } from 'ramda';
export const latestUniqByKey = (values, key) => {
    const uniqueMap = values.reduce((acc, v) => {
        const keyValue = ramdaPath(key.split('.'), v);
        if (keyValue) {
            acc[keyValue] = v;
        }
        return acc;
    }, {});
    return Object.values(uniqueMap);
};
export const useLatestBufferedThrottle = (value, key, callback, throttleDuration) => {
    useBufferedThrottle(value, (bufferedValues) => {
        const latestValues = latestUniqByKey(bufferedValues, key);
        callback(latestValues);
    }, throttleDuration);
};
//# sourceMappingURL=useLatestBufferedThrottle.js.map